import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { GrDocumentConfig } from "react-icons/gr";
import { RiCustomerService2Line } from "react-icons/ri";
import img1 from "../../../../assets/img/Consulting/rpa.jpg";

export default function MainSection4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Intelligent Automation
            </h1>
            <p className="text-lg text-gray-600">
            Use generative AI to automate repetitive tasks like document processing, code generation, and customer communications.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <GrDocumentConfig className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900"> Automated Document Processing</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Leverage generative AI to automatically extract, organize, and process data from documents, improving efficiency and accuracy.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <RiCustomerService2Line className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Streamlined Customer Communications</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Use AI to automate customer interactions, such as email responses and chat support, enhancing customer experience and reducing manual workload.
              </p>
            </div>

      
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}